import React from 'react';
import { Modal } from 'antd';
import { useNavigate } from 'react-router-dom';
import { Button } from '.';

interface PlanExpiryModalProps {
    daysRemaining: number;
    endDate: string;
    onClose: () => void;
}

const PlanExpiryModal: React.FC<PlanExpiryModalProps> = ({ daysRemaining, endDate, onClose }) => {
    const navigate = useNavigate();

    const formattedDate = new Date(endDate).toLocaleDateString('en-IN', {
        day: '2-digit',
        month: 'long',
        year: 'numeric',
    });

    const expiryText =
        daysRemaining === 0
            ? 'expires today!'
            : daysRemaining === 1
            ? 'expires in 1 day.'
            : `expires in ${daysRemaining} days.`;

    return (
        <Modal
            open
            onCancel={onClose}
            footer={null}
            centered
            closable
            title={null}
            width={400}
        >
            <div className='flex flex-col items-center gap-4 py-4 font-outfit'>
                <div className='flex items-center justify-center rounded-full bg-golden w-16 h-16'>
                    <span className='text-3xl'>⏳</span>
                </div>

                <h2 className='text-xl font-bold text-primary text-center'>
                    Premium Plan Expiring Soon
                </h2>

                <p className='text-base text-textColor text-center leading-relaxed'>
                    Your premium plan <span className='font-semibold text-primary'>{expiryText}</span>
                    <br />
                    <span className='text-sm text-textLight'>Expiry date: {formattedDate}</span>
                </p>

                <p className='text-sm text-textColor text-center'>
                    Renew your plan to keep enjoying premium features without interruption.
                </p>

                <div className='flex gap-3 justify-center mx-auto w-fit'>
                    <Button name='Renew Now' type='first' htmlType='button' onClick={() => { onClose(); navigate('/home/subscription'); }} />
                    <Button name='Later' type='second' htmlType='button' onClick={onClose} />
                </div>
            </div>
        </Modal>
    );
};

export default PlanExpiryModal;
